import { createSelector, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'noSearchResults',
    initialState: {
        showNoResults: false,
        recommendationListings: [],
        ruleTier: 0,
        searchRadius: 0,
        message: undefined,
    },
}).extend({
    selectors: () => ({
        isShowNoResults: new DuckSelector((selectors) => createSelector(
            selectors.getDuckState,
            ({ showNoResults }) => showNoResults,
        )),
    }),
});
